module.exports = __webpack_public_path__ + "static/media/weather-app.4acf5628.gif";